var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.prefixCls},[_vm._l((_vm.stateTree),function(item,i){return _c('Tree-node',{key:i,attrs:{"data":item,"visible":"","multiple":_vm.multiple,"treeNodeMode":_vm.treeNodeMode,"show-checkbox":_vm.showCheckbox,"children-key":_vm.childrenKey}})}),_vm._v(" "),(!_vm.stateTree.length)?_c('div',{class:[_vm.prefixCls + '-empty']},[_vm._v(_vm._s(_vm.localeEmptyText))]):_vm._e()],2)}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/tree/tree.vue